module.exports = __webpack_public_path__ + "img/img_about07.39bf7fd1.jpg";